import { render, staticRenderFns } from "./platformMoney.vue?vue&type=template&id=bd31499a"
import script from "./platformMoney.vue?vue&type=script&lang=js"
export * from "./platformMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports